import React, { Suspense } from 'react';
import { StorePageRouter } from './storePages.jsx';

const Dashboard = React.lazy(() => import('./Dashboard.jsx'));

export default function App() {
  return (
    <StorePageRouter>
      <Suspense fallback={<div className="dashboard-loading">Loading command center…</div>}>
        <Dashboard />
      </Suspense>
    </StorePageRouter>
  );
}
